document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
});

document.addEventListener("click", function (e) {
    if (e.target.closest("search-button") || e.target.closest(".predictive-search__reset-button")) {
        console.log("ACTION")
        window.dispatchEvent(new Event('scroll'));
    }
});